export default "__VITE_ASSET__0d6020ac__"